module.exports = __webpack_public_path__ + "media/blog/article-image-5bec2543.png";